import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  container: {
    width: "100%",
    padding: 50,
  },
  pageTitle: {
    width: "100%",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "flex-end",
  },
  title: {
    fontFamily: "rokh",
    textAlign: "right",
    fontSize: 20,
    marginTop: 10,
    fontWeight: 900,
  },
  subtitle: {
    textAlign: "right",
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 20,
  },
  recommendationsWrapper: {
    width: "100%",
    flexWrap: "wrap",
    flexDirection: "row-reverse",
    alignItems: "flex-start",
    justifyContent: "space-between",
  },
  recommendationMainItem: {
    width: "100%",
    padding: 10,
    borderRadius: 5,
    marginBottom: 5,
    border: "1 solid #ddd",
    flexDirection: "column",
  },
  recommendationItem: {
    width: "49.5%",
    height: "40%",
    padding: 10,
    borderRadius: 5,
    marginBottom: 5,
    border: "1 solid #ddd",
    flexDirection: "column",
  },
  recommendationTitle: {
    width: "100%",
    textAlign: "right",
    fontSize: 13,
    fontWeight: 900,
    fontFamily: "rokh",
    marginTop: 3,
  },
  recommendationContent: {
    width: "100%",
    textAlign: "right",
    fontSize: 10,
  },
  notPro: {
    padding: 10,
    backgroundColor: "#FFF1B8",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 5,
    width: "100%",
    height: "100px",
  },
  notProText: {
    fontWeight: 900,
    fontSize: 14,
    fontFamily: "rokh",
    marginTop: 8,
    textAlign: "center",
    lineHeight: 1.7,
  },
});

const PdfRecommendation = ({ testResults, is_pro }: any) => {
  const recommendationsList = [
    {
      id: 2,
      badge: "ارزیابی کلی",
      content: testResults?.medical_advice?.health_risk_assessment,
    },
    {
      id: 3,
      badge: "مدیریت و بهبود",
      content: testResults?.medical_advice?.management_and_treatment,
    },
    {
      id: 4,
      badge: "دمنوش و گیاهان دارویی",
      content: testResults?.medical_advice?.medicinal_plants_herbal_teas,
    },
    {
      id: 5,
      badge: "رژیم و سبک زندگی",
      content: testResults?.medical_advice?.lifestyle_dietary_advice,
    },
    {
      id: 6,
      badge: "آزمایش",
      content: testResults?.medical_advice?.complementary_tests,
    },
    {
      id: 7,
      badge: "ویتامین",
      content: testResults?.medical_advice?.useful_vitamins,
    },
  ];

  return (
    <View style={styles.container}>
      <View style={styles.pageTitle}>
        <Text style={styles.title}>تحلیل و پیشنهادات اختصاصی</Text>
        <Text style={styles.subtitle}>
          تحلیل و پیشنهادات بادی‌بان درباره آزمایش شما
        </Text>
      </View>

      <View style={styles.recommendationMainItem}>
        <Text style={styles.recommendationTitle}>
          تحلیل هوش‌مصنوعی بادی‌بان درباره آزمایش و وضعیت سلامت شما
        </Text>
        <Text style={styles.recommendationContent}>
          {testResults?.medical_advice?.user_medical_advice}
        </Text>
      </View>

      <View style={styles.recommendationsWrapper}>
        {is_pro &&
          recommendationsList.map((item) => (
            <View key={item.id} style={styles.recommendationItem}>
              <Text style={styles.recommendationTitle}>{item.badge}</Text>
              <Text style={styles.recommendationContent}>{item.content}</Text>
            </View>
          ))}
        {!is_pro && (
          <View style={styles.notPro}>
            <Text style={styles.notProText}>
              برای دیدن بقیه موارد مثل مدیریت و بهبود، دمنوش و گیاهان دارویی،
              رژیم و سبک زندگی، آزمایش، ویتامین و از همه مهم‌تر ارزیابی کلی
              هوش‌مصنوعی، تحلیل پیشرفته آزمایش رو انتخاب کنید
            </Text>
          </View>
        )}
      </View>
    </View>
  );
};

export default PdfRecommendation;
